import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { SCHEDA_PAZIENTE } from 'configs/AppConfig'
import SchedaPazienteService from "../../services/SchedaPazienteService";
import { errorMessage } from "../../utils/messages";

export const initialState = SCHEDA_PAZIENTE

export const loadSchedaPaziente = createAsyncThunk('carica-scheda-paziente', async (data, { rejectWithValue }) => {

    console.log("[loadSchedaPaziente]");

    try {
        const response = await SchedaPazienteService.getSchedaPaziente(data.id);
        let schedaPaziente = response.data.attributes
        const defaultTabKey = data.key
        const idPaziente = data.id;
        let schedaPazienteJson = {}
        
        schedaPaziente.cronologia = schedaPaziente.sales_patients == null ? [] : schedaPaziente.sales_patients.data.map(item => {
            const { id, attributes } = item;
            const { data, note, stato, referente, tipologia } = attributes;

            return {
                id: id.toString(),
                data,
                note,
                stato,
                referente,
                tipologia
            };
        });

        //ordini i stati e tipi in base alla data di creazione (decrescente)
        const state_type_patients = schedaPaziente.state_type_patients.data.sort(
            (a, b) => new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt)
        );

        schedaPaziente.stato = (state_type_patients == null || state_type_patients == undefined) ? [] : state_type_patients.map(item => {
            const { documentId, attributes } = item;
            const { stato, tipo, sede, anno_di_vendita } = attributes;
            return {
                id: documentId,
                tipo_paziente: tipo,
                stato_paziente:  stato,
                anno_di_vendita: anno_di_vendita,
                sede:sede,
                purchaseId:attributes?.purchase?.data?.documentId
            };
        });

        // const NUM_BLOCCHI_FITTIZI = 2;
        // const generateMockData = (index) => {
        //     return {
        //         id: `mock-${index}`,
        //         tipo_paziente: `TIPO${index},TIPO${index + 1}`,
        //         stato_paziente: `STATO${index},STATO${index + 1}`,
        //         anno_di_vendita: `${2020 + index},${2021 + index},${2021 + index},${2021 + index},${2021 + index},${2021 + index},${2021 + index},${2021 + index},${2021 + index}`,
        //         sede: `SEDE${index},SEDE${index + 1}`,
        //     };
        // };
        // schedaPaziente.stato = Array(NUM_BLOCCHI_FITTIZI).fill().map((_, index) => generateMockData(index + 1))
          

        schedaPazienteJson.schedaPaziente = schedaPaziente;
        schedaPazienteJson.schedaPaziente.id = response.data.documentId;
        schedaPazienteJson.defaultTabKey = defaultTabKey;

        console.table(schedaPazienteJson)
        return { schedaPaziente, defaultTabKey, idPaziente }
    } catch (err) {
        console.log("err", err)
        let message = (<div>
            Qualcosa è andato storto nel recuperare la scheda del paziente. Riprovare!
            <br />
            Se il problema persiste, contattare l' assistenza.
        </div>);
        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
})

export const schedaPaziente = createSlice({
    name: 'schedaPaziente', initialState, reducers: {
        showLoading: (state) => {
            state.loading = true
        },
        updateSchedaPaziente: (state, action) => {
            const { updatedFields } = action.payload;
            console.log("updatedFields", updatedFields);

            // Se updatedFields è un oggetto, sovrascrivi i campi esistenti
            state.schedaPaziente = {
                ...state.schedaPaziente,
                ...updatedFields
            };

            console.log("schedaPaziente DOPO", state.schedaPaziente);
        },
        getSchedaPaziente: (state, action) => {
            return state.schedaPaziente
        },
    }, extraReducers: (builder) => {
        builder
            .addCase(loadSchedaPaziente.pending, (state) => {
                state.loadingSchedaPaziente = true
                state.loadedSchedaPaziente = false
                state.errorSchedaPaziente = false
            })
            .addCase(loadSchedaPaziente.fulfilled, (state, action) => {
                state.loadingSchedaPaziente = false
                state.loadedSchedaPaziente = true
                state.schedaPaziente = action.payload.schedaPaziente
                state.defaultTabKey = action.payload.defaultTabKey
                state.idPaziente = action.payload.idPaziente
                state.errorSchedaPaziente = false
            })
            .addCase(loadSchedaPaziente.rejected, (state, action) => {
                state.loadingSchedaPaziente = false
                state.loadedSchedaPaziente = true
                state.schedaPaziente = {}
                state.defaultTabKey = 1
                state.errorSchedaPaziente = true
            })

    }
})

export const {
    updateSchedaPaziente,
    showLoading,
    getSchedaPaziente
} = schedaPaziente.actions

export default schedaPaziente.reducer;